// /orgs/$orgSlug/projects/$projectId/timeline (Stream V2).
//
// Route shell for the per-project due-date timeline. Read-only view over
// task due dates (the only mutation is the inline date editor); project
// access is enforced server-side, and 403 / 404 are surfaced here rather
// than falling through to the default boundary - mirrors the dashboard
// route.

import { createFileRoute, Link } from '@tanstack/react-router';

import { ApiError, apiErrorMessage } from '../api/client';
import { TimelinePage } from '../components/TimelinePage';

export const Route = createFileRoute(
  '/orgs/$orgSlug/projects/$projectId/timeline'
)({
  component: TimelineRoute,
  errorComponent: TimelineRouteError,
});

function TimelineRoute(): React.JSX.Element {
  const { orgSlug, projectId } = Route.useParams();
  return <TimelinePage orgSlug={orgSlug} projectId={projectId} />;
}

function TimelineRouteError({ error }: { error: unknown }): React.JSX.Element {
  const isApi = error instanceof ApiError;
  const status = isApi ? error.status : null;
  const heading =
    status === 403
      ? 'You don’t have access to this project'
      : status === 404
        ? 'Project not found'
        : 'Something went wrong loading the timeline';
  const body = apiErrorMessage(
    error,
    'Try again, or pick a different project from the organization page.'
  );

  return (
    <div className="mx-auto max-w-2xl py-7">
      <p className="text-text-faint text-11 mb-2 uppercase tracking-wider">
        Error
      </p>
      <h1 className="text-text text-28 mb-3 font-semibold">{heading}</h1>
      <p className="text-text-muted mb-5 text-13">{body}</p>
      <Link
        to="/"
        className="bg-accent text-accent-fg border-border-strong rounded-2 hover:bg-accent-hi inline-block border px-3 py-2 text-13 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
